import { render } from "./TextHeader.vue?vue&type=template&id=16883af1&scoped=true"
import script from "./TextHeader.vue?vue&type=script&lang=js"
export * from "./TextHeader.vue?vue&type=script&lang=js"

import "./TextHeader.vue?vue&type=style&index=0&id=16883af1&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16883af1"]])

export default __exports__